export default __webpack_public_path__ + "static/media/img-guide-mobile-bg.5d17f1cf.png";